export default __webpack_public_path__ + "static/media/kj.da7a312f.png";